import { render, staticRenderFns } from "./GBScheduleList.vue?vue&type=template&id=6f67c3a0&"
import script from "./GBScheduleList.vue?vue&type=script&lang=js&"
export * from "./GBScheduleList.vue?vue&type=script&lang=js&"
import style0 from "./GBScheduleList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports